import { type ReactElement } from 'react'
import { classes } from '@andyneville/tailwind-react'
import { PlayCircleIcon } from '@heroicons/react/24/solid'
import { CloudArrowUpIcon } from '@heroicons/react/24/outline'

interface LocalVideoPreviewProps {
  onClick?: () => void
  className?: string
  thumbnail: string
}

export default function LocalVideoPreview (props: LocalVideoPreviewProps): ReactElement {
  const { onClick, thumbnail, className } = props
  if (thumbnail != null && thumbnail.length > 0) {
    return (
      <div className={classes('relative cursor-pointer bg-center bg-cover rounded-lg flex items-center justify-center group', className)} style={{ backgroundImage: `url("${thumbnail}")` }} onClick={onClick}>
        <PlayCircleIcon className='w-12 h-12 text-gray-400 opacity-80 group-hover:text-brand-600 group-hover:dark:text-brand-500 group-hover:opacity-100' />
        <CloudArrowUpIcon className='absolute text-gray-50 dark:text-dark-50 bottom-0 left-0 w-6 h-6' />
      </div>
    )
  } else {
    return (
      <div className={classes('relative cursor-pointer border border-gray-400 rounded-lg flex items-center justify-center group', className)} onClick={onClick}>
        <PlayCircleIcon className='w-8 h-8 text-gray-400 group-hover:text-brand-400' />
        <CloudArrowUpIcon className='absolute text-gray-50 dark:text-dark-50 bottom-0 left-0 w-6 h-6' />
      </div>
    )
  }
}
